import React from "react";
import PageLayout from "../../shared/PageLayout";
import NewCaseTip2Layout from "./NewCaseTip2Layout";

const NewCaseTip2: React.FC = () => {
    return (
        <PageLayout>
            <NewCaseTip2Layout />
        </PageLayout>
    );
};

export default NewCaseTip2;
